var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vertical container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M11.1021 3.08194C10.5589 2.30602 9.40982 2.30602 8.86669 3.08194L7.64152 4.83225C7.56031 4.94826 7.41922 5.0067 7.27976 4.98209L5.17578 4.61076C4.24308 4.44616 3.43053 5.2587 3.59514 6.1914L3.96646 8.29539C3.99108 8.43485 3.93264 8.57593 3.81662 8.65714L2.06631 9.88232C1.2904 10.4254 1.2904 11.5746 2.06631 12.1177L3.81662 13.3429C3.93264 13.4241 3.99108 13.5652 3.96646 13.7046L3.59514 15.8086C3.43053 16.7413 4.24308 17.5538 5.17578 17.3892L7.27976 17.0179C7.41922 16.9933 7.56031 17.0517 7.64152 17.1678L8.86669 18.9181C9.40982 19.694 10.5589 19.694 11.1021 18.9181L12.3272 17.1678C12.4084 17.0517 12.5495 16.9933 12.689 17.0179L14.793 17.3892C15.7257 17.5538 16.5382 16.7413 16.3736 15.8086L16.0023 13.7046C15.9777 13.5652 16.0361 13.4241 16.1521 13.3429L17.9024 12.1177C18.6784 11.5746 18.6784 10.4254 17.9024 9.88232L16.1521 8.65714C16.0361 8.57593 15.9777 8.43485 16.0023 8.29539L16.3736 6.1914C16.5382 5.2587 15.7257 4.44616 14.793 4.61076L12.689 4.98209C12.5495 5.0067 12.4084 4.94826 12.3272 4.83225L11.1021 3.08194Z",
    fill: "#256EE8",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M6.78125 11.0016L8.70709 12.9274C8.74746 12.9678 8.81339 12.9662 8.8518 12.924L12.7812 8.60156",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verifiedIcon.a96010b4fa1e24085259bfbe380a9963.svg";
export { ForwardRef as ReactComponent };